import clsx from "clsx";

import "./style.less";
import type { ButtonProps } from "./types";

export function Button({ small, white, className, ...props }: ButtonProps) {
  return (
    <button
      className={clsx("Button-component", { small, white }, className)}
      {...props}
    />
  );
}
